export { default } from './InputLabel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/InputLabel/index.js
// module id = 330
// module chunks = 0